import { render } from "./logoView.vue?vue&type=template&id=3d5e3032&scoped=true"
const script = {}

import "./logoView.vue?vue&type=style&index=0&id=3d5e3032&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3d5e3032"]])

export default __exports__